import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { registerIcons } from './fontawsome';
import { Analytics } from './helpers/analytics/Analytics';
import { Errors } from './helpers/Errors';
import { initialiseFirebase } from './helpers/firebase/FirebaseSetup';
import { StackSwitcher } from './stacks/StackSwitcher';
import { store } from './store/Store';
import { HCPThemeProvider } from './theme/HcpThemeProvider';

Errors.initialize();
initialiseFirebase();
registerIcons();
Analytics.initialize();

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <HCPThemeProvider>
        <StackSwitcher />
      </HCPThemeProvider>
    </Provider>
  </StrictMode>,
  document.getElementById('root')
);
